export class InstancesController {
    constructor($scope, JFrogGridFactory, BinMgrDao, StatsDao, JFrogModal, GeneralDao, JFrogEventBus, $state,
                $rootScope, XRayUIState,XRayUIPermissions,JFrogTableViewOptions) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.jfrogGridFactory = JFrogGridFactory;
        this.binMgrDao = BinMgrDao;
        this.XRayUIState = XRayUIState;
        this.$state = $state;
        this.statsDao = StatsDao;
        this.modal = JFrogModal;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        $scope.$parent.Settings.showButtons = false;
        $scope.$parent.Settings.currentSubController = this;

        this.XRayUIPermissions = XRayUIPermissions;
        this.tableViewOptions = new JFrogTableViewOptions($scope);

        GeneralDao.get().$promise.then((generalData) => {
            this.isTrialActive = generalData.active_trial_license;
            this.ready = true;
            this._createGrid();
            this._getInstances();
        });


        let removeUpdateListener = JFrogEventBus.register(this.EVENTS.INSTANCES_REFRESH, () => {

            this._getInstances();

        });

        this.$scope.$on('$destroy', () => {
            removeUpdateListener();
        });

    }

    _createGrid() {

        this.tableViewOptions.setId('instances-table')
            .setObjectName('Instance')
            .setColumns(this._getColumns())
            .setRowsPerPage(20)
            .setActions(this._getActions())


        this.tableViewOptions.emptyTableCallActionText = 'Add a new Instance';

        if(!this.XRayUIState.getState('isSaas')){
            this.tableViewOptions.setNewEntityAction(() => {
                this.$state.go('^.instances.new')
                this.tableViewOptions.update();
            });
            this.tableViewOptions.emptyTableText = 'Currently there are no Instance configured';
            this.tableViewOptions.emptyTableAction = () => {
                this.$state.go('^.instances.new')
            }
            this.tableViewOptions.newEntityCustomText = 'New Instance';

        }

        //.setBatchActions(getBatchActions())


    }

    _getInstances() {
        this.binMgrDao.get().$promise.then(instances => {

            if (this.XRayUIState.getState('isSaas')) {
                if (instances.length) {
                    this.$state.go('settings.instances.edit', {instanceID: instances[0].binMgrId})
                }
            }

            if (instances.length === 0) {
                this.tableViewOptions.setData([]);
            } else {
                this.tableViewOptions.setData(instances);
                let payload = [];
                instances.forEach(instance => payload.push({binMgrId: instance.binMgrId, repoKeys: []}));
                this.instances = instances
                instances.forEach((i) => {
                    let id = i.BinMgrId;
                    let instance = _.find(this.instances, {binMgrId: id});
                    i.licenseStatus = !i.license_valid ? 'INVALID' : i.license_expired ? 'EXPIRED' : 'VALID';
                });
                this.tableViewOptions.setData(this.instances);
            }
        });
    }

    getInstanceCount(row) {
        row.fetchingData = true;
        let payload = [{binMgrId: row.binMgrId, repoKeys: []}]
        if (!this.$rootScope.licenseInvalid) {
            this.statsDao.getNumOfArtifacts({$no_spinner: true}, payload).$promise.then((data) => {
                data.forEach((statItem) => {
                    let id = statItem.bin_mgr_stats.bin_mgr_id;
                    let instance = _.find(this.instances, {binMgrId: id});
                    instance.pendingScanFiles = statItem.bin_mgr_stats.pending_scan;
                    instance.scannedFiles = statItem.bin_mgr_stats.scanned;
                    instance.severities = statItem.bin_mgr_stats.top_severities_count;
                });

            });

        }
    }

    deleteInstance(row) {


        let modalScope = this.$scope.$new();

        modalScope.input = {};
        modalScope.artId = row.binMgrId;

        if (row.is_access) {

            let message = `Currently, <strong>${row.binMgrId}</strong> is being used as Authentication Provider. Choose another option as Authentication Provider in order to remove <strong>${row.binMgrId}</strong> from Xray.`;
            this.modal
                .confirm(message, 'Authentication Provider',
                    {confirm: 'Update Authentication Settings', cancel: 'Cancel'})
                .then(
                    () => this.$state.go('settings.authentication')
                );
        }
        else {
            this.modal.launchModal('delete_connection_modal', modalScope).result.then(() => {
                this.binMgrDao.deleteConnection({
                    binMgrId: row.binMgrId,
                    user: modalScope.input.adminUser,
                    password: modalScope.input.adminPass
                }).$promise.then(() => {
                    this._getInstances();
                }).catch(() => {
                    this._getInstances();
                });
            });
        }
    }

    refreshLicense(row) {
        this.binMgrDao.refreshLicenseInfo({}, {binMgrId: row.binMgrId}).$promise.then((response) => {
            this._getInstances();
        });
    }

    _getColumns() {
        let columns = [
            {
                name: 'ID',
                header: 'ID',
                field: 'binMgrId',
                cellTemplate: `<div class="ui-grid-cell-contents" ui-sref="settings.instances.edit({instanceID: row.entity.binMgrId})"><a class="jf-link" href="">{{row.entity.binMgrId}} <i jf-tooltip="Access Provider" ng-if="row.entity.is_access" class="icon icon-expire"></i> </a></div>`,
                width: '15%'
            },
            {
                name: 'Artifactory URL',
                header: 'Artifactory URL',
                cellTemplate: '<div class="ui-grid-cell-contents"><a  class="jf-link" target="_blank" href="{{row.entity.binMgrUrl}}">{{row.entity.binMgrUrl}}</a></div>',
                field: 'binMgrUrl',
                width: !this.isTrialActive ? '25%' : '25%'
            },
            {
                name: 'version',
                header: 'Version',
                field: 'version',
                width: '15%'
            },
        ];

        if (!this.isTrialActive) {
            columns.push({
                name: 'License',
                header: 'License',
                field: 'licenseStatus',
                width: '20%',
                cellTemplate: `<div class="ui-grid-cell-contents" ng-if="!grid.appScope.Instances.$rootScope.licenseInvalid">{{row.entity.licenseStatus}}</div> <div class="ui-grid-cell-contents" ng-if="grid.appScope.Instances.$rootScope.licenseInvalid">N/A</div>`
            });
        }
        columns.push({
            name: 'Scanned Artifacts',
            header: 'Scanned Artifacts',
            cellTemplate: `<div ng-if="(row.entity.pendingScanFiles || row.entity.pendingScanFiles=='0') && ( row.entity.scannedFiles || row.entity.scannedFiles=='0') " class="ui-grid-cell-contents">  {{row.entity.pendingScanFiles}} Pending | {{row.entity.scannedFiles}} Scanned:<span ng-bind-html="grid.appScope.Instances.getScannedTooltip(row.entity)"></span> </div> <div ng-style="{ 'padding-top' : (row.entity.fetchingData) ? '9px' : '0' }" class="ui-grid-cell-contents" ng-if="!grid.appScope.Instances.$rootScope.licenseInvalid && !row.entity.pendingScanFiles && row.entity.pendingScanFiles !== 0"><div> <div ng-if="row.entity.fetchingData" class="icon icon-hourglass"></div><a ng-if="!row.entity.fetchingData" ng-click="grid.appScope.Instances.getInstanceCount(row.entity)">Calculate</a></div></div><div class="ui-grid-cell-contents" ng-if="grid.appScope.Instances.$rootScope.licenseInvalid && !row.entity.pendingScanFiles && row.entity.pendingScanFiles !== 0">N/A</div>`,
            field: 'pendingScanFiles',
            width: '60%'
        });

        return columns;
    }

    _getActions() {
        return [
            {
                icon: 'icon icon-refresh',
                tooltip: 'Refresh Config',
                callback: row => this.refreshLicense(row)
            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteInstance(row),
                visibleWhen: (row) => !this.XRayUIState.getState('isSaas')
            }
        ];
    }

    getScannedTooltip(row){
        return `<span class="severity high">High:&nbsp${row.severities.High}&nbsp</span><span class="severity medium">Medium:&nbsp${row.severities.Medium}&nbsp</span><span class="severity low">Low:&nbsp${row.severities.Low || 0}&nbsp</span><span class="severity normal">Scanned - No issues:&nbsp${row.severities["Scanned - No Issues"]}</span>`
    }
}


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/instances/instances.controller.js